import React, { useEffect, useRef, useState } from "react";
import { jobBooking } from "../services/index";
import moment from "moment";

let img_url = process.env.REACT_APP_API_BASEURL;
const statusLabelMap = {
  // BOOKING_CONFIRMED: "Exp Pickup Dt",
  SHIPMENT_AT_WAREHOUSE: "Exp Pickup Dt",
  DEPARTED: "Exp Dept Dt",
  ARRIVED: "Exp Arr Dt",
  DELIVERED: "Exp Del Dt",
};

export default function Track() {
  const tracking = useRef();
  const [trackngData, setTrackingData] = useState({});
  const [lastValidItem, setLastValidItem] = useState(null);
  const [lastValidDate, setLastValidDate] = useState(null);

  const trackShipment = () => {
    getTrackingDetails(tracking.current.value);
  };

  const getTrackingDetails = (jobToken) => {
    try {
      let queryData = { job_token: jobToken };
      jobBooking.getTrackingDetails(queryData).then((result) => {
        if (result.status === true) {
          const data = result.data;
          if (
            data.origin_country &&
            data.destination_country &&
            data.origin_country === data.destination_country
          ) {
            const job_status_values = [
              data.job_status_values[0],
              data.job_status_values[2],
              data.job_status_values[4],
            ];
            setTrackingData({ ...data, job_status_values });
          } else {
            setTrackingData(result.data);
          }
        } else {
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  // let lastValidItem = {}

  // useEffect(()=>{
  //   lastValidItem = trackngData?.job_status_values && [...trackngData?.job_status_values]
  //     .reverse()
  //     .find(
  //       (item) =>
  //         ["BOOKING_CONFIRMED", "SHIPMENT_AT_WAREHOUSE", "DEPARTED", "DELIVERED"].includes(
  //           item.job_status
  //         ) && item.change_date !== 0
  //     );
  // }, [trackngData?.job_status_values])

  useEffect(() => {
    if (
      trackngData?.job_status_values &&
      trackngData?.job_status_values.length > 0
    ) {
      const foundItem = [...trackngData?.job_status_values]
        .reverse()
        .find(
          (item) =>
            ["BOOKING_CONFIRMED", "SHIPMENT_AT_WAREHOUSE", "DEPARTED", "ARRIVED"].includes(
              item.job_status
            ) && item.change_date !== 0
        );

      setLastValidItem(foundItem || null);
    }
  }, [trackngData?.job_status_values]);

  useEffect(() => {
    if (
      trackngData?.job_status_values &&
      trackngData?.job_status_values.length > 0
    ) {
      const foundItem = [...trackngData?.job_status_values]
        .reverse()
        .find(
          (item) =>
            [
              "BOOKING_CONFIRMED",
              "SHIPMENT_AT_WAREHOUSE",
              "DEPARTED",
              "ARRIVED",
              "DELIVERED",
            ].includes(item.job_status) && item.change_date !== 0
        );

      setLastValidDate(foundItem || null);
    }
  }, [trackngData?.job_status_values]);

  return (
    <>
      <section className="pb-5 pt-0">
        <div className="header_title">
          <div className="container-fluid">
            <h1>Track Your Shipment</h1>
            <p>
              Please enter information below and click on the "Track" button.
            </p>
            <img
              src="/assets/images/track.jpg"
              className="bannerimg"
              alt="Not found"
            />
          </div>
        </div>
        <div className="container-fluid mt-5">
          <div className="white_box h-100">
            <div className="row">
              <div className="col-md-6 px-md-5 px-3">
                <form>
                  <div className="form-group mb-3">
                    <label className="fw-bold mb-2">Booking Ref. No. </label>
                    <input
                      className="form-control rounded_input"
                      ref={tracking}
                      placeholder="Booking REf. No"
                    />
                  </div>

                  <div className="form-group mb-3">
                    <button
                      type="button"
                      className="themebutton"
                      onClick={() => trackShipment()}
                    >
                      Track Shipment
                    </button>
                  </div>
                </form>
              </div>
              <div className="col-md-6 px-md-5 px-3">
                <label className="fw-bold mb-2">
                  Expected Delivery Date :{" "}
                  {trackngData?.expacted_date
                    ? moment(trackngData.expacted_date).format("DD-MM-YYYY")
                    : ""}
                </label>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 px-3">
                <div id="trackingSec" className="trackingSec">
                  {trackngData?.user_logo && (
                    <img
                      className="user-logo"
                      src={img_url + "/" + trackngData?.user_logo}
                      alt="Not found"
                    />
                  )}
                  <div className="w-100">
                    {Array.isArray(trackngData.job_status_values) &&
                      trackngData.job_status_values.map((item, key) => {
                        return (
                          <div
                            className={
                              item.change_date !== 0 ? "active w-100" : "w-100"
                            }
                          >
                            <div className={`trackingText-${key + 1}`}>
                              {lastValidItem &&
                              lastValidItem.text &&
                              lastValidItem.text === item.text &&
                              lastValidDate?.job_status !== "DELIVERED"
                                ? lastValidItem.text
                                : ""}
                            </div>
                            <span className="checkicon"></span>
                            <div
                              className={`text-center ${
                                item === lastValidItem ? "p-3" : "pb-5"
                              }`}
                            >
                              <div
                                style={
                                  item === lastValidItem
                                    ? { position: "relative", top: "-10px" }
                                    : {}
                                }
                              >
                                <p
                                  style={{
                                    lineHeight: key === 1 ? "1.3" : "1.5",
                                  }}
                                  className={`mb-0 ${
                                    item === lastValidItem ? "mt-0" : "mt-1"
                                  }`}
                                >
                                  {/* {item.job_status.replace(/_/g, " ")}{" "} */}
                                  {/* {item.job_status &&
                                    item.job_status
                                      .replace(/_/g, " ")
                                      .split(" ")
                                      .map((word, index) => (
                                        <React.Fragment key={index}>
                                          {word}
                                          {index !==
                                            item.job_status
                                              .replace(/_/g, " ")
                                              .split(" ").length -
                                              1 && <br />}
                                        </React.Fragment>
                                      ))} */}

                                  {item.job_status &&
                                    (() => {
                                      const words = item.job_status
                                        .replace(/_/g, " ")
                                        .split(" ");
                                      return words.map((word, index) => (
                                        <React.Fragment key={index}>
                                          {word}
                                          {(index !== words.length - 1 &&
                                            !(
                                              word === "SHIPMENT" &&
                                              words[index + 1] === "AT"
                                            ) && <br />) ||
                                            " "}
                                        </React.Fragment>
                                      ));
                                    })()}
                                </p>
                                <p className="mb-0 mt-1 lh-1">
                                  {(item?.tracking_date &&
                                    moment(item?.tracking_date).format(
                                      "DD-MM-YYYY"
                                    )) ||
                                    "-"}{" "}
                                </p>
                              </div>
                            </div>
                            {item === lastValidDate &&
                              lastValidDate.job_status !== "DELIVERED" && (
                                <div
                                  className="text-center"
                                  style={{
                                    position: "relative",
                                    top:
                                      key === 0
                                        ? "-98px"
                                        : key === 1
                                        ? "-89px"
                                        : "-79px",
                                    // top: "-71px",
                                    // left: "50%",
                                    left: "59%",
                                  }}
                                >
                                  {/* <p className="mb-0 lh-1">Expected Date</p> */}

                                  <p className="mb-0 lh-1">
                                    {/* {statusLabelMap[item.job_status] || "Expected Date"} */}
                                    {statusLabelMap[
                                      trackngData.job_status_values[key + 1]
                                        ?.job_status
                                    ] || "Expected Date"}
                                  </p>

                                  <p className="mb-0 lh-1">
                                    {trackngData.job_status_values[key + 1]
                                      ?.job_status === "DELIVERED"
                                      ? trackngData?.expacted_date
                                        ? moment(
                                            trackngData.expacted_date
                                          ).format("DD-MM-YYYY")
                                        : "-"
                                      : trackngData?.next_stage_expected_date
                                      ? moment(
                                          trackngData.next_stage_expected_date
                                        ).format("DD-MM-YYYY")
                                      : "-"}
                                  </p>
                                </div>
                              )}
                          </div>
                        );
                      })}
                  </div>
                </div>
                {trackngData.remarks && (
                  <div style={{ paddingLeft: "2rem" }}>
                    Remarks :- {trackngData.remarks}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
